'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createSvg = require('./utils/createSvg');

var _createSvg2 = _interopRequireDefault(_createSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSvg2.default)(_react2.default.createElement(
  'g',
  null,
  _react2.default.createElement('path', { d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z' })
), 'ViewStream');


//////////////////
// WEBPACK FOOTER
// ./~/material-react-icons/ViewStream.js
// module id = 977
// module chunks = 0